export enum MenuItemType {
  SIDEPANEL = 'SIDEPANEL',
  LINK = 'LINK',
  POST = 'POST',
  BUTTONSET = 'BUTTONSET',
  TOGGLE = 'TOGGLE',
  DIALOG = 'DIALOG',
  DRAGDROP = 'DRAGDROP',
  GENERATE_VOTING_LETTER = 'GENERATE_VOTING_LETTER',
  SET_DECISION = 'SET_DECISION',
  CABINET_EVALUATION = 'CABINET_EVALUATION',
  AGENDAPOINT_MOVE = 'AGENDAPOINT_MOVE',
  MAIL_DIALOG = 'MAIL_DIALOG',
  MANAGE_VOTING_RESULTS = 'MANAGE_VOTING_RESULTS',
  IMPORT_VOTING_RESULTS_CONFERO = 'IMPORT_VOTING_RESULTS_CONFERO',
  MANAGE_ADDITIONAL_INFO = 'MANAGE_ADDITIONAL_INFO',
  MESSAGE = 'MESSAGE',
  WEBCAST_ARBOR_CREATE = 'WEBCAST_ARBOR_CREATE',
  WEBCAST_ARBOR_UPDATE = 'WEBCAST_ARBOR_UPDATE',
  WEBCAST_ARBOR_PUBLISH = 'WEBCAST_ARBOR_PUBLISH',
  WEBCAST_ARBOR_LINK_CREATE = 'WEBCAST_ARBOR_LINK_CREATE',
  WEBCAST_ARBOR_LINK_UPDATE = 'WEBCAST_ARBOR_LINK_UPDATE',
  WEBCAST_ROYALCAST_CREATE = 'WEBCAST_ROYALCAST_CREATE',
  AGENDAPOINTS_RELEASE = 'AGENDAPOINTS_RELEASE',
  DECREES_SIGN = 'DECREES_SIGN',
  EXPORT = 'EXPORT',
  EDIT_DETAILS = 'EDIT_DETAILS',
  DELETE_MEETING = 'DELETE_MEETING',
  PUBLICATIONS_VIEW = 'PUBLICATIONS_VIEW',
  PUBLICATIONS_GENERATE = 'PUBLICATIONS_GENERATE',
  CHANGE_DATE = 'CHANGE_DATE',
  CHANGE_DATE_SECOND = 'CHANGE_DATE_SECOND',
  SHOW_VOTING_RESULTS = 'SHOW_VOTING_RESULTS',
  EDIT_NOTES = 'EDIT_NOTES',
  ICON = 'ICON',
  EMPTY = 'EMPTY',
  DOWNLOAD = 'DOWNLOAD',
  ADDITIONAL_INFO = 'ADDITIONAL_INFO',
  SCENARIO = 'SCENARIO',
  EDIT_ANNOUNCEMENT = 'EDIT_ANNOUNCEMENT',
  COMMENTS = 'COMMENTS',
  EDIT_TREATMENT_TIME = 'EDIT_TREATMENT_TIME',
  MARK_DISCUSSION_POINT = 'MARK_DISCUSSION_POINT',
  MARK_DISCUSSION_POINT_USERS = 'MARK_DISCUSSION_POINT_USERS',
  MARK_PRE_APPROVAL_POINT = 'MARK_PRE_APPROVAL_POINT',
  MARK_PRE_APPROVAL_POINT_USERS = 'MARK_PRE_APPROVAL_POINT_USERS',
  MARK_MAJOR_POINT = 'MARK_MAJOR_POINT',
  MARK_MAJOR_POINT_USERS = 'MARK_MAJOR_POINT_USERS',
  EDIT_LINKED_MEETINGS = 'EDIT_LINKED_MEETINGS',
  VIEW_LINKED_MEETINGS = 'VIEW_LINKED_MEETINGS'
}

export enum FullScreen {
  ALWAYS = 'always',
  OPTIONAL = 'optional'
}

export enum DialogType {
  'SIMPLE' = 'SIMPLE',
  'ADVANCED' = 'ADVANCED'
}
